import { Pipe, PipeTransform } from '@angular/core';

import { isEmpty } from '@core/helpers';

@Pipe({
  name: 'userNicknameColor'
})
export class UserNicknameColor implements PipeTransform {
  transform(nicknameColor: string|null): string {
    return !isEmpty(nicknameColor) ? `nickname_color-${ nicknameColor }` : '';
  }
}